import { Container, Sprite, TextStyle, Text, FederatedPointerEvent } from "pixi.js";
import { Event } from "event-system";
import { HourlyBonusResourcePackage } from "../resources/HourlyBonusResourcePackage";
import { SoundsResourcePackageWrapper } from "../../../../common/resources/SoundsResourcePackageWrapper";
import { ButtonWithScaleAndPosYAnimation } from "../../../../common/components/ButtonWithScaleAndPosYAnimation";
import { GameFont } from "../../../../common/GameFont";

export class SpinButton extends Container {
    private static readonly SPIN_FOR_FREE_TEXT = "FREE\nSPIN";

    public get onSpinClicked(): Event<ButtonWithScaleAndPosYAnimation, FederatedPointerEvent> {
        return this.spinButton.onUp;
    }
    private readonly wheelResources: HourlyBonusResourcePackage;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private spinButtonBg: Sprite;
    private spinButton: ButtonWithScaleAndPosYAnimation;
    private spinButtonText: Text;
    private isLocked: boolean;

    public constructor(
        wheelResources: HourlyBonusResourcePackage,
        soundResources: SoundsResourcePackageWrapper
    ) {
        super();
        this.wheelResources = wheelResources;
        this.soundResources = soundResources;
        this.build();
    }

    private build(): void {
        this.spinButtonBg = new Sprite(this.wheelResources.assets_views_hourly_bonus_button_bg_png);
        this.spinButtonBg.anchor.set(0.5, 0.5);
        this.addChild(this.spinButtonBg);
        this.spinButton = new ButtonWithScaleAndPosYAnimation(this.wheelResources.assets_views_hourly_bonus_wheel_button_green_png, this.soundResources.assets_sounds_Choose_Card_mp3);
        this.spinButton.position.set(-this.spinButton.width * 0.5, -this.spinButton.height * 0.5 - 40);
        this.addChild(this.spinButton);
        this.spinButtonText = new Text(SpinButton.SPIN_FOR_FREE_TEXT, new SpinButtonTextStyle());
        this.spinButton.defaultView.addChild(this.spinButtonText);
        this.spinButtonText.position.set((this.spinButton.width - this.spinButtonText.width) * 0.5, (this.spinButton.height - this.spinButtonText.height) * 0.5 - 20);
    }

    public lockButton(): void {
        if (this.isLocked) {
            return;
        }
        this.isLocked = true;
        this.spinButton.defaultView.texture = this.wheelResources.assets_views_hourly_bonus_daily_wheel_gray_png;
        this.spinButtonText.visible = false;
        this.spinButton.interactive = false;
    }

    public unlockButton(): void {
        if (!this.isLocked) {
            return;
        }
        this.isLocked = false;
        this.spinButton.defaultView.texture = this.wheelResources.assets_views_hourly_bonus_wheel_button_green_png;
        this.spinButtonText.visible = true;
        this.spinButton.interactive = true;
    }
}

class SpinButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 62,
            leading: 10
        }));
    }
}
